import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import {Regex} from 'commons/constants';
import {LoginValues} from 'commons/models';
import PropTypes, {InferProps} from 'prop-types';
import InnerFormLogin from './InnerFormLogin';
import {Utils} from 'commons';

LoginForm.propTypes = {
    createUser: PropTypes.func.isRequired,
    submitHandler: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
};

const FormControl = withFormik<InferProps<typeof LoginForm.propTypes>, LoginValues>({
    mapPropsToValues: () => {
        return {username: '', password: ''};
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: LoginValues) => {
        const errors: FormikErrors<LoginValues> = {};
        if (!values.username) {
            errors.username = Utils.messageFunctions.getRequiredMessage('Usuario');
        } else {
            if (!Regex.USERNAME.test(values.username.toUpperCase())) {
                errors.username = Utils.messageFunctions.getRegexMessage('Usuario');
            }
        }
        if (!values.password) {
            errors.password = Utils.messageFunctions.getRequiredMessage('Contrase\u00F1a');
        } else {
            if (values.password.length < 8) {
                errors.password = ' ';
            }
        }
        return errors;
    },
    handleSubmit: async (values, actions) => {
        actions.setSubmitting(false);
        await actions.props.submitHandler(values);
    },
})(InnerFormLogin);

function LoginForm(props: InferProps<typeof LoginForm.propTypes>) {
    const {submitHandler, isLoading, createUser} = props;
    return (
        <FormControl submitHandler={submitHandler} isLoading={isLoading} createUser={createUser} />
    );
}

export default LoginForm;
